import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserServices } from 'src/app/services/user.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  currentStep: 'userType' | 'faq' | 'contact' = 'userType';
  userType: 'publisher' | 'company' | null = null;
  contactForm: FormGroup;
  sending = false;

  faqQuestions = [
    {
      text: 'Quiero ganar dinero, ¿cómo empiezo?',
      url: 'https://imperatool.com/guia-publicacion'
    },
    {
      text: 'No me aparecen reseñas para hacer',
      url: 'https://imperatool.com/guia-publicacion'
    },
    {
      text: '¿Cómo se pagan mis publicaciones?',
      url: 'https://imperatool.com/faq#usuario'
    }
  ];

  constructor(
    private fb: FormBuilder,
    private _user: UserServices,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required]
    });

    // Si recibimos datos pre-rellenados, vamos directamente al formulario
    if (data && data.formData) {
      this.currentStep = 'contact';
      this.contactForm.patchValue(data.formData);
    }
  }

  selectUserType(type: 'publisher' | 'company') {
    this.userType = type;
    if (type === 'company') {
      this.currentStep = 'contact';
    } else {
      this.currentStep = 'faq';
    }
  }

  showContactForm() {
    this.currentStep = 'contact';
  }

  goBack() {
    // Si el formulario viene pre-rellenado, cerramos el diálogo en lugar de volver atrás
    if (this.data && this.data.formData) {
      this.dialogRef.close();
      return;
    }

    if (this.currentStep === 'faq') {
      this.currentStep = 'userType';
      this.userType = null;
    } else if (this.currentStep === 'contact' && this.userType === 'publisher') {
      this.currentStep = 'faq';
    } else {
      this.currentStep = 'userType';
      this.userType = null;
    }
  }

  navigateToFaq(url: string) {
    window.open(url, '_blank');
    this.dialogRef.close();
  }

  async sendMessage() {
    if (this.contactForm.valid && !this.sending) {
      this.sending = true;
      try {
        await this._user.contact(
          this.contactForm.value.name,
          this.contactForm.value.email,
          this.contactForm.value.message,
        ).toPromise();
        this.snackBar.open('Mensaje enviado correctamente. Te responderemos lo antes posible.', 'OK', {
          duration: 5000
        });
        this.contactForm.reset();
        this.dialogRef.close();
      } catch (error) {
        this.snackBar.open('Error al enviar el mensaje. Por favor, inténtalo de nuevo.', 'OK', {
          duration: 5000
        });
      }
      this.sending = false;
    }
  }
}
